import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconClose, IconGroup } from '@travel-frontend/icons';
import { useCallback, useEffect, useState } from 'react';
import { Container } from '../../components/ScarcityElement/components/Container.js';
import { Content } from '../../components/ScarcityElement/components/Content.js';
import { Control } from '../../components/ScarcityElement/components/Control.js';
import { useTracking } from '../../hooks/index.js';
import { LabelSmall, ParagraphLargeBold, Stack } from '../../primitives/index.js';
import { qaId, SCARCITY_ELEMENT_QA_ID } from '../../utils/qaId.js';
import { SPACING_NONE } from '../../utils/spacingLegacy.js';
export const ScarcityElement = ({
  title,
  content,
  timeOff = 86_400_000,
  storageKey = 'scarcityElementDismissedAt',
  icon: Icon = IconGroup,
  ariaLabel,
  isDynamic
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const {
    trackClickEvent,
    trackLoadEvent
  } = useTracking();
  useEffect(() => {
    const dismissedAt = localStorage.getItem(storageKey);
    if (isVisible) {
      if (isDynamic) {
        trackLoadEvent('dyn_scarcity_element_load', {
          event: 'scarcity',
          non_interaction: true
        });
      } else {
        trackLoadEvent('stat_scarcity_element_load', {
          event: 'scarcity',
          non_interaction: true
        });
      }
    }
    if (dismissedAt) {
      const timeDiff = Date.now() - Number(dismissedAt);
      if (timeDiff < timeOff) {
        setIsVisible(false);
        return;
      }
      localStorage.removeItem(storageKey);
    }
    setIsVisible(true);
  }, [isVisible, isDynamic, storageKey, timeOff, trackLoadEvent]);
  const dismiss = useCallback(() => {
    try {
      localStorage.setItem(storageKey, String(Date.now()));
    } catch (error) {
      console.error('Error writing to localStorage:', error);
    }
    if (isDynamic) {
      trackClickEvent('dyn_scarcity_element', {
        event: 'scarcity'
      });
    } else {
      trackClickEvent('stat_scarcity_element', {
        event: 'scarcity'
      });
    }
    setIsVisible(false);
  }, [storageKey, isDynamic, trackClickEvent]);
  if (!isVisible) {
    return null;
  }
  return _jsxs(Container, {
    "data-testid": qaId(SCARCITY_ELEMENT_QA_ID),
    children: [_jsxs(Content, {
      children: [_jsx(Icon, {}), _jsxs(Stack, {
        spacing: SPACING_NONE,
        children: [_jsx(ParagraphLargeBold, {
          color: "systemErrorAlert",
          children: title
        }), _jsx(LabelSmall, {
          children: content
        })]
      })]
    }), _jsx(Control, {
      "aria-label": ariaLabel,
      onClick: dismiss,
      children: _jsx(IconClose, {})
    })]
  });
};